import { ProjectReportTable } from '@/version2/pages/project-report/project-report-table'

export const ProjectReportPage = () => {
    return <ProjectReportTable />
}
